module.exports = __webpack_public_path__ + "img/polos.19346943.svg";